import { TeamRow } from "@suns/api/generated-client/apollo";

export const CapStatusLabels = {
  [TeamRow.capStatus.UNDER_CAP]: "Under Cap",
  [TeamRow.capStatus.OVER_CAP]: "Over Cap",
  [TeamRow.capStatus.IN_THE_TAX]: "In the Tax",
  [TeamRow.capStatus.FIRST_APRON]: "First Apron",
  [TeamRow.capStatus.SECOND_APRON]: "Second Apron",
};
